<template>
  <Row>
    <Col span="24">
      <Row :gutter="25">
        <Col :sm="24" :md="24" :lg="24" :xl="24">
          <Card class="sum-card-box" :padding="0" style="border: 0px solid #efefef;background:#f5f5f5">
            <div class="header_box">
            </div>
            <div class="wrapp">
              <div class="earch_box">
                <div :style="{ width: '100%', height: height }" :id="uuid"></div>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </Col>
  </Row>
</template>
<script>
import * as echarts from 'echarts';
export default {
  name: 'workSum',
  components: {},
  data() {
    return {
      id: null,
      chart: null,
      xAxisArr: [],
      data: null,
    }
  },
  props: {
    title: {
      type: String,
      default: '工单数量',
    },
    height: {
      type: String,
      default: '300px',
    },
  },
  computed: {
    uuid() {
      if (!this.id) {
        this.id = 'chart_data_id' + Math.ceil(Math.random() * 1000)
      }
      return this.id
    },
  },
  created() {},
  mounted() {
    this.initChart()
    //当前日期
  },
  methods: {
    initChart() {
      let q = {}
      this.chart && this.chart.showLoading()
      $utils.api
        .load('homeGetWork', q, 'get')
        .then((res) => {
          if (res.code > 0) {
            let obj = res.data.work || {}
            let finished = obj.finished || 0
            let pending = obj.pending || 0
            let processing = obj.processing || 0
            let total = Number(finished) + Number(pending) + Number(processing)
            this.chart = echarts.init(document.getElementById(this.uuid), 'light')
            const option = {
              tooltip: {
                trigger: 'item',
              },
              legend: {
                top: '0%',
                left: 'center',
              },
              color: ['#f7ac40', '#4ed39a', '#5491f8'],
              graphic: [
                {
                  type: 'text', //通过不同top值可以设置上下显示
                  left: 'center',
                  top: '45%',
                  style: {
                    text: `工单总数`,
                    textAlign: 'center',
                    fill: '#000', //文字的颜色
                    width: 30,
                    height: 30,
                    fontSize: 16,
                    color: '#4d4f5c',
                    fontFamily: 'Microsoft YaHei',
                  },
                },
                {
                  type: 'text', //通过不同top值可以设置上下显示
                  left: 'center',
                  top: '55%',
                  style: {
                    text: `${total}`,
                    textAlign: 'center',
                    fill: '#000', //文字的颜色
                    width: 30,
                    height: 30,
                    fontSize: 14,
                    color: 'rgb(16, 16, 16,.3)',
                    fontFamily: 'Microsoft YaHei',
                  },
                },
              ],
              series: [
                {
                  name: '',
                  type: 'pie',
                  radius: ['55%', '75%'],
                  avoidLabelOverlap: false,
                  hoverAnimation: false,
                  label: {
                    show: false,
                    position: 'center',
                  },
                  emphasis: {
                    label: {
                      show: false,
                      fontSize: '15',
                      fontWeight: 'bold',
                    },
                  },
                  labelLine: {
                    show: false,
                  },
                  data: [
                    { value: pending, name: '待处理' },
                    { value: finished, name: '已完成' },
                    { value: processing, name: '处理中' },
                  ],
                },
              ],
            }
            this.chart.setOption(option)
            window.addEventListener('resize', () => {
              this.chart.resize()
            })
            // 折现设置点击事件，点击查询当天日期的每小时数据
          }
          this.chart && this.chart.hideLoading()
        })
        .catch((e) => {
          // console.log(e)
          // $utils.toast.error('数据异常' + e.message)
          this.chart && this.chart.hideLoading()
        })
    },
  },
}
</script>
<style lang="less" scoped>
.sum-card-box {
  float: left;
  width: 100%;
  height: 420px;
  margin-bottom: 10px;
  box-sizing: border-box;
  background-color: #f9f9f9;
  transition: 0.2s all ease;
  position: relative;
  padding: 20px 24px 8px;
  .header_box {
    display: flex;
    align-items: center;
  }
  .header_br {
    width: 4px;
    height: 20px;
    background-color: rgb(228, 4, 19);
  }
  .header_title {
    font-family: SourceHanSansSC;
    font-weight: 700;
    font-size: 15px;
    color: rgb(16, 16, 16);
    font-style: normal;
    letter-spacing: 0px;
    text-decoration: none;
    margin-left: 10px;
  }
  .wrapp {
    display: flex;
    align-items: center;
    margin-top: 30px;
    justify-content: center;
    .earch_box {
      width: 100%;
    }
  }
  .box {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .item {
      display: flex;
      align-items: center;
      justify-items: center;
      margin-left: 15px;
      margin-right: 10px;
      margin-top: 20px;
      .image {
        width: 15px;
        height: 15px;
        background: #ccc;
        border-radius: 15px;
        margin-right: 10px;
      }
      .left {
        display: flex;
        align-items: flex-start;
        justify-items: center;
        flex-direction: column;
      }
      .num {
        font-family: SourceHanSansSC;
        font-weight: 400;
        font-size: 13px;
        color: rgb(16, 16, 16);
        font-style: normal;
      }
      .title {
        font-family: SourceHanSansSC;
        font-weight: 400;
        font-size: 13px;
        color: rgb(16, 16, 16, 0.3);
        font-style: normal;
        margin-top: 10px;
      }
    }
  }
  .item3 {
    height: 0px;
    margin-bottom: 2px;
    width: 100%;
  }
  .item4 {
    border-top: 1px solid #e8e8e8;
    padding-top: 5px;
    margin-top: 8px;
    font-size: 14px;
    line-height: 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    span:last-child {
      margin-left: 8px;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}
</style>
